<template>
    <div class="flat-mail-input" id="flat-mail-input" v-if="salesCard != null">
        <form class="form-in" v-if="formVisible" @submit="sendFlatMail">
            <div class="form-group">
                <input type="email" name="email" class="form-control"  autocomplete="off" placeholder="E-mail" v-model="email" v-validate="{rules: { required: true, regex: regexRules.email }}">
            </div>
            <div class="btn-send">
                <button class="btn-submit btn-success" type="button" @click="sendFlatMail" :disabled="errors.any()">
                    <svgIcon name="plane" class="icon-plane"/>
                </button>
            </div>
        </form>
        <div class="successMessage" v-else>
            <h3>отправлено</h3>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'formMail',
        props: ['options'],
        data () {
            return {
                formVisible: true,
                email: '',
                regexRules: {
                    email: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/
                }
            }
        },
        components: {
            svgIcon,
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
        }),
        methods: {
            sendFlatMail(e) {
                e.preventDefault();
                var querystring = require('querystring');
                // var urlForm = '/formFlat.php';
                var urlFlatForm = 'https://admin.shablon.bazis.kz/server/form-flat.php';
                var data = {
                    'pdf': this.options[0].pdf,
                    'name': this.options[0].name,
                    'path_logo': './static/' + this.salesCard.project_name.slug + '/images/logo.png',
                    'path_bazis': './static/' + this.salesCard.project_name.slug + '/images/bazis.png',
                    'path_index_pic': './static/' + this.salesCard.project_name.slug + '/images/index-pic.jpg',
                    'path_phone': './static/' + this.salesCard.project_name.slug + '/images/phone.png',
                    'path_html': './static/' + this.salesCard.project_name.slug + '/send_flat.html',
                    'subject': 'Ваша кваритра в ' + this.CapitalizeID(this.salesCard.project_name.slug),
                    'mail': this.email
                };
                // if (window.host == 'yassytower') {
                //     urlForm = '/formFlatLandYassy.php'
                //     var data = {
                //         'pdf': this.options[0].pdf,
                //         'name': this.options[0].name,
                //         'mail': this.email
                //     };
                // }
                this.$validator.validate().then(result => {
                    if(result) {
                        this.formVisible = false
                        // console.log(data);
                        axios.post(urlFlatForm, querystring.stringify(data));
                        // axios.get(this.options[0].pdf).then((response) => {
                        //     console.log(response)
                        // });
                       
                    } else {
                        console.log('Form Send mail with errors');
                    }
                });
            },
            CapitalizeID(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            },
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-mail.scss';
    @import '@/styles/components/forms/forms-respond/form-mail-respond.scss';
</style>